<template>
  <div :class="isBusy !== 'init' ? !isBusy ? '' : 'show' : ''" class="body-overlay position-fixed">
    <span class="loader"></span>
    <p>{{currentStep}}</p>
    <p>{{steps}}</p>
    <div v-if="steps" class="progress-bar">
      <div id="progress" ref="progressBar" class="progress"></div>
    </div>
  </div>
</template>
<script>
import {GET_BUSY} from "@/store/overlay/const";
import {GET_STEPS, GET_STEP, SET_STEPS} from "@/store/loadingBar/const";

export default {
  name: "Overlay",
  watch: {
    currentStep(val) {
      val && this.runProgress(val);
    }
  },

  data() {
    return {
      
    }
  },
  methods: {
    runProgress: function (val) {
      if (this.steps) {
        this.$refs.progressBar.style.width = Math.round(val * 100 / this.steps) + '%';
      }
    }
  },
  computed: {
    isBusy() {
      return this.$store.getters[`overlay/${GET_BUSY}`];
    },
    steps() {
      return parseInt(this.$store.getters[`loadingBar/${GET_STEPS}`]);
    },
    currentStep() {
      return parseInt(this.$store.getters[`loadingBar/${GET_STEP}`]);
    }

  }, mounted() {
    this.$store.commit(`loadingBar/${SET_STEPS}`, 0);
  }
}
</script>
<style scoped>
.body-overlay.show {
  display: block;
  height: 100vh;
  width: 100vw;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 900;
}

.body-overlay.show .loader {
  width: 60px;
  height: 60px;
  display: inline-block;
  position: relative;
  transform: rotate(45deg) translate(-100%, -25%);
  left: 50%;
  top: 50%;
}

.body-overlay.show .loader::before {
  content: '';
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  position: absolute;
  left: 0;
  top: -30px;
  animation: animloader 4s ease infinite;
}

.body-overlay.show .loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  animation: animloader2 2s ease infinite;
}

@keyframes animloader {
  0% {
    box-shadow: 0 30px rgba(255, 255, 255, 0), 30px 30px rgba(255, 255, 255, 0), 30px 60px rgba(255, 255, 255, 0), 0px 60px rgba(255, 255, 255, 0);
  }

  12% {
    box-shadow: 0 30px white, 30px 30px rgba(255, 255, 255, 0), 30px 60px rgba(255, 255, 255, 0), 0px 60px rgba(255, 255, 255, 0);
  }

  25% {
    box-shadow: 0 30px white, 30px 30px white, 30px 60px rgba(255, 255, 255, 0), 0px 60px rgba(255, 255, 255, 0);
  }

  37% {
    box-shadow: 0 30px white, 30px 30px white, 30px 60px white, 0px 60px rgba(255, 255, 255, 0);
  }

  50% {
    box-shadow: 0 30px white, 30px 30px white, 30px 60px white, 0px 60px white;
  }

  62% {
    box-shadow: 0 30px rgba(255, 255, 255, 0), 30px 30px white, 30px 60px white, 0px 60px white;
  }

  75% {
    box-shadow: 0 30px rgba(255, 255, 255, 0), 30px 30px rgba(255, 255, 255, 0), 30px 60px white, 0px 60px white;
  }

  87% {
    box-shadow: 0 30px rgba(255, 255, 255, 0), 30px 30px rgba(255, 255, 255, 0), 30px 60px rgba(255, 255, 255, 0), 0px 60px white;
  }

  100% {
    box-shadow: 0 30px rgba(255, 255, 255, 0), 30px 30px rgba(255, 255, 255, 0), 30px 60px rgba(255, 255, 255, 0), 0px 60px rgba(255, 255, 255, 0);
  }
}

@keyframes animloader2 {
  0% {
    transform: translate(0, 0) rotateX(0) rotateY(0);
  }

  25% {
    transform: translate(100%, 0) rotateX(0) rotateY(180deg);
  }

  50% {
    transform: translate(100%, 100%) rotateX(-180deg) rotateY(180deg);
  }

  75% {
    transform: translate(0, 100%) rotateX(-180deg) rotateY(360deg);
  }

  100% {
    transform: translate(0, 0) rotateX(0) rotateY(360deg);
  }
}

.progress-bar {
  width: 35%;
  height: 10px;
  background-color: #404040;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  bottom: 35%;
  border-radius: .5rem;
}

.progress {
  width: 0%;
  height: 100%;
  background-color: #ffffff;
  transition: width 1s ease;
}

@media screen and (max-width: 991px) {
  .progress-bar {
    width: 70%;
    height: 5px;
    bottom: 40%;
  }
}
</style>